import { useEffect, useState } from "react";

export function useDelayedVisibility(isOpen: boolean, delayMs = 10) {
	const [shouldShow, setShouldShow] = useState(false);

	useEffect(() => {
		if (isOpen) {
			const timer = setTimeout(() => setShouldShow(true), delayMs);
			return () => clearTimeout(timer);
		}
		setShouldShow(false);
	}, [isOpen, delayMs]);

	return shouldShow;
}
